import React, { useCallback, useContext, useMemo } from 'react';
import { CustomViewsState } from './CustomViewsState';
import { isNil } from 'lodash';
import { ErrorBoundaryConstellation } from '../../../../../constellationExtended/ErrorBoundary/ErrorBoundaryConstellation';

interface CustomViewsStateContext {
  customViewsState: CustomViewsState;
  setCustomViewsState: React.Dispatch<React.SetStateAction<CustomViewsState>>;
}

// this is the state of a closed dropdown
const initialCustomViewsContext: CustomViewsState = {
  isOpen: false,
  isCreate: false,
  isEdit: false,
  updatingView: null,
  formikData: null,
};

const CustomViewsContext = React.createContext<CustomViewsStateContext | null>(null);

export const CustomViewsContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [customViewsState, setCustomViewsState] = React.useState<CustomViewsState>(() => initialCustomViewsContext);
  const memoizedValue = useMemo(() => {
    return { customViewsState, setCustomViewsState };
  }, [customViewsState]);

  return (
    <ErrorBoundaryConstellation>
      <CustomViewsContext.Provider value={memoizedValue}>{children}</CustomViewsContext.Provider>
    </ErrorBoundaryConstellation>
  );
};

export const useCustomViewsContext = () => {
  const context = useContext(CustomViewsContext);
  if (isNil(context)) {
    throw new Error('useCustomViewsContext must be used within a CustomViewsContextProvider');
  }
  const { customViewsState, setCustomViewsState } = context;
  const resetContext = useCallback(() => setCustomViewsState(initialCustomViewsContext), [setCustomViewsState]);

  return { customViewsState, setCustomViewsState, resetContext };
};
